import styled from 'styled-components';
import React, { useEffect } from 'react';
import { useRef } from 'react';
const RadioContainer = styled.label `
  user-select: none;
  position: relative;
  margin-right: 0;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  letter-spacing: 0;
  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    overflow: visible;
    z-index: -1;
    padding: 0;
  }
  ${props => props.disabled ? 'cursor: not-allowed; opacity: .4;' : ''}
  span {
    height: 16px;
    min-height: 16px;
    width: 16px;
    min-width: 16px;
    border-radius: 50%;
    border-width: 1px;
    border-color: ${props => props.theme.input.borderColors.default};
    background: #fff;
    top: 1px;
    position: relative;
  }
  span:after {
    content: "";
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: ${props => props.theme.colors.text};
    position: absolute;
    border-radius: 50%;
    display: none;
    transform: scale(.5);
  }
  & input:checked ~ span:after {
    display: block;
  }
  &:hover input:not([disabled]) ~ span {
    background-color: #FFF;
  }
  & input:checked ~ span {
    background-color: #FFF;
  }
`;
const RadioLabel = styled.div `
  margin-left: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  flex:1 1 0%;
`;
export const Radio = React.forwardRef((props, ref) => {
    const wrapperRef = useRef();
    useEffect(() => {
        if ((wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) && props.checked) {
            try {
                wrapperRef.current.querySelector('input').checked = true;
            }
            catch (error) { }
        }
    }, [wrapperRef, props.checked]);
    const onInputChange = (e) => {
        const isControlled = !!props.checked;
        const value = isControlled ? props.checked : e.target.checked;
        if (props.disabled)
            return;
        if (props.onChange) {
            props.onChange(value || false);
        }
        if (props.onBlur) {
            props.onBlur();
        }
        if (props.onBlur) {
            props.onBlur();
        }
    };
    const onClick = () => {
        if (props.disabled) {
            return;
        }
        if (props.onClick) {
            props.onClick();
        }
    };
    return React.createElement(RadioContainer, { disabled: props.disabled, onClick: () => onClick(), fullWidth: props.fullWidth, ref: wrapperRef },
        React.createElement("input", { "data-cy": `radio ${props.name}`, ref: ref, type: "radio", value: props.value, disabled: !!props.disabled, name: props.name, onChange: onInputChange }),
        React.createElement("span", null),
        (props.label || props.children) && React.createElement(RadioLabel, null, props.label || props.children));
});
Radio.defaultProps = {
    checked: false,
    disabled: false
};
